import { Button, Typography } from '@breetometer/components';
import { ResendWebhookIcon } from 'BreetAssets';
import { handleApiError, showToast } from 'BreetHelpers';
import { closeModal, selectModals, useAppDispatch, useAppSelector, useResendWebhookByReferenceMutation } from 'BreetRedux';
import { useCallback } from 'react';

export const DialogResendWebhook = () => {
	const modals = useAppSelector(selectModals);

	const dispatch = useAppDispatch();

	const selectedModal = modals.find((modal) => modal.id === 'resendWebhook');

	const webHookLogData = selectedModal?.metadata as { reference: string } | undefined;

	const [resendWebhookByReference, { isLoading: resendWebhookLoading }] = useResendWebhookByReferenceMutation();

	const handleWebhookResend = useCallback(() => {
		if (!webHookLogData?.reference) {
			showToast('error', 'Something went wrong');
			return;
		}

		resendWebhookByReference(webHookLogData.reference)
			.unwrap()
			.then(() => {
				dispatch(closeModal('resendWebhook'));
			})
			.catch(handleApiError);
	}, [dispatch, resendWebhookByReference, webHookLogData?.reference]);

	return (
		<div className='dialog-resend-webhook bg-primary-500'>
			<ResendWebhookIcon />
			<Typography
				as='h4'
				className='color-primary-50'
			>
				Resend Webhook
			</Typography>
			<Typography className='color-primary-100'>Are you sure you want to resend this webhook?</Typography>
			<Button
				onClick={handleWebhookResend}
				isLoading={resendWebhookLoading}
				className='primary-hover'
			>
				Yes, Resend
			</Button>
		</div>
	);
};
